import { ColumnEditorPanelComponent } from './column-editor-panel.component';
import {
  CanColumnTypeHaveDefaultValuePipe,
  CanDataTypeHaveDefaultValuePipe,
  DatasetLabelPipe,
  IsRequiredUniqueAvailablePipe,
  ShouldShowUniqueSwitchPipe,
} from './column-editor-panel.pipes';

export const COLUMN_EDITOR_PANEL_COMPONENTS = [
  ColumnEditorPanelComponent,
  IsRequiredUniqueAvailablePipe,
  DatasetLabelPipe,
  ShouldShowUniqueSwitchPipe,
  CanDataTypeHaveDefaultValuePipe,
  CanColumnTypeHaveDefaultValuePipe,
];
